import type { ApiMeta } from "@/apis/types";

/**
 * API metadata for WSDOT Weather Readings API
 */
export const wsdotWeatherReadingsApiMeta: ApiMeta = {
  name: "wsdot-weather-readings",
  baseUrl: "https://www.wsdot.wa.gov/traffic/api/api",
};
